import { css } from 'lit';

export const ETitleStyles = css`
  :host {
    --fs-text-color-disabled: black;
    --fs-form-text-color-helper-disabled: #333333;
  }

  .etitle-container {
    margin: 0 auto;
    max-width: var(--fs-breakpoint-medium-large, 48rem);
    padding: 0 var(--fs-size-spacing-medium-2, 24px);
  }

  .etitle-container .actions > * {
    display: block;
  }

  .etitle-container,
  #etitle-form,
  #etitle-form .additional-info {
    display: grid;
    row-gap: var(--fs-size-medium-2, 24px);
  }

  .borrower-info {
    padding-left: 5px;
    padding-right: 5px;
  }

  .coborrower-info {
    border-style: solid;
    border-width: 1px;
    margin-top: -0.75em;
    border-radius: 4px;
    padding: 16px 12px 16px 16px;
    border-color: #d4d4d4;
  }

  .coborrower-info fs-heading {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
  }

  refi-etitle-modal {
    margin-bottom: var(--fs-size-spacing-medium-1, 16px);
  }

  .etitle-container #poata-heading {
    font-weight: bold;
    font-size: var(--fs-font-size-medium-3, 1.5rem);
  }

  ul {
    margin: 0.5rem auto 0;
    line-height: 1.5;
  }

  li {
    line-height: 2rem;
  }

  fs-accordion-item-content {
    line-height: 1.5;
  }

  #MichiganBorrowerDLState > span {
    color: black;
  }

  #DCBorrowerDLState > span {
    color: black;
  }

  #skip-btn {
    margin-bottom: 8px;
  }

  #skip-span {
    font-weight: bold;
  }
`;
